import { Camera } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { InsuranceIndication } from '../../models/insuranceIndication'

export interface IndicationScreenshotsDialogProps {
  indication: InsuranceIndication
}

/**
 * CAI-admin-only dialog listing the carrier-portal screenshots captured while
 * the automation submitted this indication (one per form submission + errors).
 */
export function IndicationScreenshotsDialog({ indication }: IndicationScreenshotsDialogProps) {
  const screenshots = indication.submissionScreenshots ?? []
  if (screenshots.length === 0) return null

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" variant="link">
          Screenshots ({screenshots.length})
          <Camera className="h-3 w-3" />
        </Button>
      </DialogTrigger>
      <DialogContent size="xl" className="max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{indication.vendorName} submission screenshots</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-6">
          {screenshots.map((screenshot) => (
            <div key={screenshot.id} className="flex flex-col gap-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium break-all">{screenshot.fileName}</span>
                <span className="text-muted-foreground text-xs whitespace-nowrap">
                  {new Date(screenshot.dateCreated).toLocaleString()}
                </span>
              </div>
              {screenshot.url && (
                <a href={screenshot.url} target="_blank" rel="noopener noreferrer">
                  <img
                    src={screenshot.url}
                    alt={screenshot.fileName}
                    loading="lazy"
                    className="w-full rounded-md border"
                  />
                </a>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
